/**
 * Browser-side Telegram Mini App mock for local development.
 *
 * When VITE_MOCK_TG=true, calls `mockTelegramEnv` from @telegram-apps/sdk to
 * fake a TG WebView environment. This makes `retrieveRawInitData()` and other
 * SDK functions work in a regular browser instead of throwing.
 *
 * The generated initData is structurally valid but has a fake HMAC hash, so
 * the backend will reject it. For end-to-end logged-in testing in a browser,
 * use the dev token input on the /login page (also gated by VITE_MOCK_TG).
 */

import { mockTelegramEnv } from "@telegram-apps/sdk-react";
import { MOCK_TG } from "@kupikupi/brand";

export function initMockTelegram() {
  if (!MOCK_TG) return;

  const initDataRaw = new URLSearchParams();
  initDataRaw.set("query_id", "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
  initDataRaw.set(
    "user",
    JSON.stringify({
      id: 123456789,
      first_name: "Dev",
      last_name: "Tester",
      username: "dev_tester",
      language_code: "zh",
    }),
  );
  initDataRaw.set("auth_date", String(Math.floor(Date.now() / 1000)));
  initDataRaw.set(
    "hash",
    "0000000000000000000000000000000000000000000000000000000000000000",
  );
  initDataRaw.set(
    "signature",
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
  );

  mockTelegramEnv({
    launchParams: {
      tgWebAppPlatform: "web",
      tgWebAppVersion: "7.0",
      tgWebAppThemeParams: {
        bg_color: "#ffffff",
        text_color: "#000000",
        hint_color: "#999999",
        link_color: "#229ED9",
        button_color: "#229ED9",
        button_text_color: "#ffffff",
      },
      tgWebAppData: initDataRaw,
    },
  });

  console.log("[mock-tg] Telegram Mini App env mocked (MOCK_TG=true)");
}
